export default [
  {
    path: '/activity-20260526-main',
    component: () => import('./Page.vue'),
    meta: { title: '礼物返场', id: 30 },
  },
  {
    path: '/activity-20260526-rule',
    component: () => import('./Rule.vue'),
    meta: { title: '礼物返场-规则', id: 30 },
  },
]
